import {EntityData, field, identifier} from "../entity/entity.data";

export class ReportRequestData extends EntityData<ReportRequestData> {

    public static readonly STATUS_REQUESTED = "REQUESTED";
    public static readonly STATUS_CANCELLED = "CANCELLED";
    public static readonly STATUS_FAILED = "FAILED";
    public static readonly STATUS_COMPLETE = "COMPLETE";
    public static readonly STATUS_NOPAGES = "NOPAGES";

    @identifier identifier: string;
    @field userId: string;
    @field username: string;
    @field nameSpace: string;
    @field report: string;
    @field entityId: string;
    @field criteria: string;
    @field status: string;
    @field contentType: string;
}
